module.exports = __webpack_public_path__ + "static/img/tellamamos.1ddbb967.jpg";